/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
==========================================================================================*/

import httpClient from "src/axios";
import axios from "axios";

const mutations = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val;
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val;
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width;
  },

  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex(
      item => item.url == payload.url
    );

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked =
      payload.val;

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(
        state.navbarSearchAndPinList["pages"].data[index]
      );
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex(
        item => item.url == payload.url
      );

      // remove item using index
      state.starredPages.splice(index, 1);
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10);
    state.starredPages = list.concat(starredPagesMore);
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false;
    let lastItemInStarredLimited = state.starredPages[10];
    const starredPagesLimited = state.starredPages.slice(0, 10);
    state.starredPages = starredPagesLimited.concat(list);

    state.starredPages.slice(0, 10).map(i => {
      if (list.indexOf(i) > -1) downToUp = true;
    });

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited);
    }
  },

  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val;
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val;
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  async SET_USER_INFO(state, payload) {
    state.userInfo = payload;
    if (payload) {
      state.userinformation = `${payload.name} ${payload.family}`
    } else {
      state.userinformation = ''
    }
  },

  async SET_ACCESS_TOKEN(state, authToken) {
    const token = authToken ? 'Bearer ' + authToken : null
    httpClient.defaults.headers.common['Authorization'] = token
    axios.defaults.headers.common["Authorization"] = token;
    if (token) {
      state.authToken = token;
    } else {
      state.authToken = ''
    }
  },

  SET_ACCOUNT_INFO(state, payload) {
    state.accountInfo = payload;
  },

  async SET_REFRESH_TOKEN(state, refreshToken) {
    if (refreshToken) {
      state.refreshToken = refreshToken
    } else {
      state.refreshToken = ''
    }
  },

  async SET_USER_STEP(state, userStep) {
    if (userStep) {
      await localStorage.setItem('userStep', userStep)
    } else {
      await localStorage.removeItem('userStep')
    }
  },
  async SET_USER_ID(state, userId) {
    if (userId) {
      state.userId = userId
    } else {
      state.userId = ''
    }
  },
  SET_TOKEN_EXPIRED(state, tokenExpired) {
    state.tokenExpired = tokenExpired
  },
  SET_CURRENT_TICKET(state, payload) {
    state.currentTicket = payload
  },
  SET_CATEGORIES(state, payload) {
    state.categories = payload
  },
  SET_USER_EXIST_ERROR(state, payload) {
    state.UserExistError = payload
  },
  SET_REFERENCE(state, payload) {
    state.ref = payload
  }
}

export default mutations;
